import { IFile } from '../global/file';

export interface ISentEmail {
  id: number;
  template: ITemplate;
  subject: string;
  attachments: IAttachments[];
  journeyCodes: string[];
  bookingCode: string;
  sendDate: string;
  created: string;
  status: string;
  prefferedLocale: string;
  preferredEmailThemeId: number;
  emailTemplateId: number;
  fromName: string;
  toName: string;
  fromEmailAddress: string;
  toEmailAddress: string;
  data: string;
  sent: string;
  softBounced: boolean;
  hardounces: boolean;
  blocked: boolean;
  compiledSubject: string;
  compiledBody: string;
  lastEventStatus: string;
}

export interface ITemplate {
  id: number;
  type: string;
  locale: string;
}

export interface IAttachments {
  mimeType: string;
  fileName: string;
  fileId: number;
  file: IFile;
}

export interface IResendEmailParams {
  id: number;
  toEmailAddresses: string[];
}

export enum SendgridEventStatusType {
  Processed = 'PROCESSED',
  Dropped = 'DROPPED',
  Delivered = 'DELIVERED',
  Deferred = 'DEFERRED',
  Bounce = 'BOUNCE',
  Blocked = 'BLOCKED',
  Open = 'OPEN',
  Click = 'CLICK',
  SpamReport = 'SPAM_REPORT',
  Unsubscribe = 'UNSUBSCRIBE',
  GroupUnsubscribe = 'GROUP_UNSUBSCRIBE',
  GroupResubscribe = 'GROUP_RESUBSCRIBE',
}

export const SendgridEventStatusTypeDisplayName = {
  [SendgridEventStatusType.Processed]: 'Processed',
  [SendgridEventStatusType.Dropped]: 'Dropped Portal',
  [SendgridEventStatusType.Delivered]: 'Delivered',
  [SendgridEventStatusType.Deferred]: 'Deferred',
  [SendgridEventStatusType.Bounce]: 'Bounce',
  [SendgridEventStatusType.Blocked]: 'Blocked',
  [SendgridEventStatusType.Open]: 'Open',
  [SendgridEventStatusType.Click]: 'Click',
  [SendgridEventStatusType.SpamReport]: 'Spam Report',
  [SendgridEventStatusType.Unsubscribe]: 'Unsubscribe',
  [SendgridEventStatusType.GroupUnsubscribe]: 'Group Unsubscribe',
  [SendgridEventStatusType.GroupResubscribe]: 'Group Resubscribe',
};

export interface ISentEmailStatusHistory {
  received: string;
  status: string;
}
